import React, { useEffect, useState, useMemo } from "react";

import {
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Row,
  CardBody,
  Col,
  Card,
  CardHeader,
  Modal,
} from "reactstrap";

import { Tooltip } from "@mui/material";
// RangeSlider
import "nouislider/distribute/nouislider.css";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "./TableContainer";

//Import actions
import {
  getUsers as onGetUsers,
  editUser as onEditUser,
} from "../../slices/thunks";

// import Select from "react-select";
import bcrypt from "bcryptjs-react";
//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import Loader from "../../Components/Common/Loader";
import moment from "moment";
import AddUser from "./AddUser";
import { userType } from "../../Components/constants/layout";
import DebouncedInput from "../../Components/Common/DebouncedInput";
import EditUser from "./EditUser";
import { Link } from "react-router-dom";

const Users = (props) => {
  const dispatch = useDispatch();
  const [detailsModal, setDetailsModal] = useState(false);
  const [openAddUser, setOpenAddUser] = useState(false);
  const [openEditUser, setOpenEditUser] = useState(false);
  const [openResetPassword, setOpenResetPassword] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [selectedMembershipType, setSelectedMembershipType] = useState([]);
  const [selectedSubscriptionStatus, setSelectedSubscriptionStatus] = useState(
    []
  );

  const selectUsersData = createSelector(
    (state) => state.Users,
    (users) => users.users,
    (pagination) => pagination,
    (loading) => loading
  );
  // Inside your component
  const { users, pagination, loading } = useSelector(selectUsersData);
  const [selectedUserType, setSelectedUserType] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [selectedMulti, setselectedMulti] = useState(null);
  const [product, setProduct] = useState(null);

  const [searchText, setSearchText] = useState(null);
  const [sortBy, setSortBy] = useState("user_id");
  const [sortAsc, setSortAsc] = useState(false);

  function handleMulti(selectedMulti) {
    setselectedMulti(selectedMulti);
  }

  useEffect(() => {
    if (users) {
      setUsersList(users);
      setFirstLoad(false);

      setUsersList(users);
    }
  }, [dispatch, users]);
  /*
  useEffect(() => {
    setUsersList(suppliers);
  }, [suppliers]);

  useEffect(() => {
    if (!isEmpty(suppliers)) setUsersList(suppliers);
  }, [suppliers]);
*/

  const getSubscriptonStatusText = (status) => {
    const statusText = [];
    if (status.includes("active")) {
      statusText.push("active");
      statusText.push("trialing");
    }
    if (status.includes("canceled")) {
      statusText.push("deleted");
    }
    return statusText.length > 0 ? statusText.toString() : null;
  };

  useEffect(() => {
    getUsers();
  }, [selectedMembershipType, searchText, selectedUserType, selectedSubscriptionStatus, sortBy, sortAsc]);

  const getUsers = (page, pageSize, download) => {
    const data = {
      page: page ? page : 0,
      total_rows: pageSize ? pageSize : pagination ? pagination?.pageSize : 50,
      searchText: searchText,
      sort_by: sortBy,
      asc: sortAsc,
      MembershipType: selectedMembershipType.length > 0 ? selectedMembershipType.toString() : null,
      type: selectedUserType.length > 0 ? selectedUserType.toString() : null,
      subscription_status:
        selectedSubscriptionStatus.length > 0
          ? getSubscriptonStatusText(selectedSubscriptionStatus)
          : null,
      download: download || false,
    };
    dispatch(onGetUsers(data));
  };

  const changePassword = () => {
    if (newPassword) {
      const data = {
        ...selectedUser,
        user_password: bcrypt.hashSync(newPassword, 10),
      };
      dispatch(onEditUser(data));
    }
  };
  /*
  useEffect(() => {
    getUsers();
  }, []);
*/
  //delete order
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (product) => {
    setProduct(product);
    setDeleteModal(true);
  };

  const onClickView = (product) => {
    setProduct(product);
    setDetailsModal(true);
  };
  /*
  const handleDeleteProduct = () => {
    if (users) {
      dispatch(onDeleteSupplier(users._id));
      setDeleteModal(false);
    }
  };
*/
  // Displat Delete Button
  const [dele, setDele] = useState(0);
  const displayDelete = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };

  const handleValidDate = (date) => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  const getTypeColor = (type) => {
    switch (type) {
      case userType.ADMIN:
        return "bg-danger";
      case userType.FINALANALYSIS:
        return "bg-warning";
      case userType.STOCKCHECK:
        return "bg-info";
      case userType.INITIALANALYSIS:
        return "bg-primary";
      case userType.BC:
        return "bg-success";
      default:
        return "bg-secondary";
    }
  };

  /*
  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element");
    ele.forEach((element) => {
      dispatch(onDeleteSupplier(element.value));
      setTimeout(() => {
        toast.clearWaitingQueue();
      }, 3000);
      del.style.display = "none";
    });
  };
*/
  const columns = useMemo(
    () => [
      {
        header: "Name",
        accessorKey: "user_name",
        enableColumnFilter: false,
      },
      {
        header: "E-mail",
        accessorKey: "user_email",
        enableColumnFilter: false,
      },
      {
        header: "Sign Up Date",
        accessorKey: "user_creationDate",
        enableColumnFilter: false,
        cell: (cell) =>
          cell.getValue() ? (
            <>
              {moment(cell.getValue()).format("MM/DD/YYYY")}
              <br />
              <small className="text-muted">
                {moment(cell.getValue()).format("hh:mm A")}
              </small>
            </>
          ) : (
            <span className="text-muted">No date available</span>
          ),
      },
      {
        header: "Company",
        accessorKey: "user_company",
        enableColumnFilter: false,
        cell: (cell) => cell.getValue() || "",
      },
      {
        header: "Type of Membership",
        accessorKey: "user_free",
        enableColumnFilter: false,
        cell: (cell) => {
          const isFree = cell.getValue() === true;
          const freeType = cell.row.original.user_freeType || "";

          if (!isFree) {
            return (
              <span
                style={{ width: "110px" }}
                className="badge text-dark text-uppercase bg-info"
              >
                Regular Member
              </span>
            );
          }

          return (
            <div className="d-flex flex-column gap-1 align-items-start">
              <span
                style={{ width: "110px" }}
                className="badge text-dark text-uppercase bg-success"
              >
                Free
              </span>
              <span
                style={{ width: "110px" }}
                className="badge text-dark text-uppercase bg-success"
              >
                {freeType || "Other"}
              </span>
            </div>
          );
        },
        sortingFn: (rowA, rowB, columnId) => {
          const aFree = rowA.getValue(columnId);
          const bFree = rowB.getValue(columnId);

          // Primary sort: user_free (boolean)
          // We want true (Free) to be grouped together.
          // If we want "Free" to come before "Regular", true < false? No, usually false (0) < true (1).
          // Let's assume standard boolean sort: false (0) then true (1).
          // If aFree != bFree, return difference.
          if (aFree !== bFree) {
            return aFree === bFree ? 0 : aFree ? 1 : -1;
          }

          // Secondary sort: user_freeType (string)
          // Only matters if both are free (or both are not free, but not free types are likely empty or same)
          const aType = rowA.original.user_freeType || "";
          const bType = rowB.original.user_freeType || "";

          return aType.localeCompare(bType);
        },
      },
      {
        header: "Status",
        accessorKey: "user_enabled",
        enableColumnFilter: false,
        cell: (cell) => (
          <span
            style={{ width: "110px" }}
            className={
              cell.getValue()
                ? "badge text-dark text-uppercase bg-success"
                : "badge text-dark text-uppercase bg-danger"
            }
          >
            <p className="mb-0">{cell.getValue() ? "Active" : "Inactive"}</p>
          </span>
        ),
      },
      {
        header: "Subscription status",
        accessorKey: "user_subscriptionStatusText",
        enableColumnFilter: false,
        cell: (cell) =>
          cell.getValue() ? (
            <>
              <span
                style={{ width: "110px" }}
                className={
                  cell.getValue() == "active"
                    ? "badge text-dark text-uppercase bg-success"
                    : "badge text-dark text-uppercase bg-danger"
                }
              >
                {cell.getValue()}
                <p className="mb-0">
                  {cell.row.original.user_subscriptionFrequency}
                </p>
                {cell.row.original.user_cancellationDate && (
                  <p className="mb-0 text-dark">
                    <small>
                      cancel at
                      <br />
                      {moment(cell.row.original.user_cancellationDate).format(
                        "MM/DD/YYYY"
                      )}
                      <br />
                      <small>
                        {moment(cell.row.original.user_cancellationDate).format(
                          "hh:mm A"
                        )}
                      </small>
                    </small>
                  </p>
                )}
              </span>
            </>
          ) : (
            <span
              style={{ width: "110px" }}
              className="badge text-dark text-uppercase bg-danger"
            >
              No Subscription
            </span>
          ),
      },
      {
        header: "Last Login Date",
        accessorKey: "user_lastLoginDate",
        enableColumnFilter: false,
        cell: (cell) =>
          cell.getValue() ? (
            <>
              {moment(cell.getValue()).format("MM/DD/YYYY")}
              <br />
              <small className="text-muted">
                {moment(cell.getValue()).format("hh:mm A")}
              </small>
            </>
          ) : (
            <span className="text-muted">No login yet</span>
          ),
      },
      {
        header: "QS Step",
        accessorKey: "user_quickStartStep",
        enableColumnFilter: false,
        cell: (cell) =>
          cell.getValue() !== undefined && cell.getValue() !== null ? (
            <span>{cell.getValue()}</span>
          ) : (
            <span className="text-muted">-</span>
          ),
      },
      {
        header: "Channels Added",
        accessorKey: "user_channelsAdded",
        enableColumnFilter: false,
        cell: (cell) => {
          const val = cell.getValue();
          if (val === undefined || val === null || val === "") {
            return <span className="text-muted">-</span>;
          }
          const channels = Array.isArray(val)
            ? val
            : String(val).split(",").map((c) => c.trim()).filter(Boolean);
          const colors = ["bg-primary", "bg-success", "bg-info", "bg-warning", "bg-secondary", "bg-danger"];
          return (
            <div className="d-flex flex-column gap-1 align-items-start">
              {channels.map((channel, idx) => (
                <span
                  key={idx}
                  className={`badge text-dark text-uppercase ${colors[idx % colors.length]}`}
                >
                  {channel}
                </span>
              ))}
            </div>
          );
        },
      },
      {
        header: "Action",
        cell: (cellProps) => {
          return (
            <>
              <Tooltip title="Edit user" className="me-2">
                <Link
                  to="#"
                  className="text-primary d-inline-block"
                  onClick={() => {
                    setSelectedUser(cellProps?.row.original);
                    setOpenEditUser(true);
                  }}
                >
                  <i className="ri-pencil-fill fs-16"></i>
                </Link>
              </Tooltip>
              <Tooltip title="Reset password">
                <Link
                  to="#"
                  className="text-primary d-inline-block"
                  onClick={() => {
                    setSelectedUser(cellProps?.row.original);
                    setOpenResetPassword(true);
                  }}
                >
                  <i className="ri-key-fill fs-16 text-danger"></i>
                </Link>
              </Tooltip>
            </>
          );
        },
      },
    ],
    []
  );

  document.title = "Users | Buyers Club";

  return (
    <div className="page-content">
      <AddUser open={openAddUser} onClose={() => setOpenAddUser(false)} />
      <EditUser
        open={openEditUser}
        onClose={() => setOpenEditUser(false)}
        user={selectedUser}
      />
      <Modal
        isOpen={openResetPassword}
        toggle={() => setOpenResetPassword(false)}
        centered={true}
        size="md"
        className="modal-dialog-centered"
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Reset Password</h5>
          <button
            onClick={() => setOpenResetPassword(false)}
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <div className="text-center">
            <lord-icon
              src="https://cdn.lordicon.com/gsqxdxog.json"
              trigger="loop"
              colors="primary:#f7b84b,secondary:#f06548"
              style={{ width: "100px", height: "100px" }}
            ></lord-icon>
            <div className="mt-4 pt-2 fs-15">
              <p className="text-muted mb-0">
                <h5>
                  Are you sure you want to reset the password for{" "}
                  <span className="text-primary">
                    {selectedUser?.user_name}
                  </span>
                  ?
                </h5>
              </p>
              <div className="mt-4">
                <label htmlFor="newPassword" className="form-label">
                  New Password
                </label>
                <input
                  type="text"
                  id="newPassword"
                  className="form-control"
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => setOpenResetPassword(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => {
              changePassword();
              setOpenResetPassword(false);
            }}
          >
            Reset Password
          </button>
        </div>
      </Modal>

      <Container fluid>
        <BreadCrumb title="Users List" pageTitle="Users" />
        <Row>
          <div className="col-xl-12">
            <Card>
              <CardHeader className="border-0">
                <Row className="align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">Users </h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-5 flex-wrap">
                      <div className="dropdown d-inline-block">
                        <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn btn-light"
                            type="button"
                            caret
                          >
                            Filter by Subscription Status
                          </DropdownToggle>
                          <DropdownMenu>
                            {[
                              { value: "active", label: "Active" },
                              { value: "canceled", label: "Canceled" },
                            ].map((status) => (
                              <DropdownItem key={status.value} toggle={false}>
                                <div className="form-check">
                                  <input
                                    checked={
                                      Array.isArray(selectedSubscriptionStatus)
                                        ? selectedSubscriptionStatus.includes(
                                          status.value
                                        )
                                        : false
                                    }
                                    name={status.value}
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`filter-subscription-${status.value}`}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      const updated = checked
                                        ? [
                                          ...(selectedSubscriptionStatus ||
                                            []),
                                          status.value,
                                        ]
                                        : (
                                          selectedSubscriptionStatus || []
                                        ).filter(
                                          (item) => item !== status.value
                                        );
                                      setSelectedSubscriptionStatus(updated);
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`filter-subscription-${status.value}`}
                                  >
                                    {status.label}
                                  </label>
                                </div>
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <div className="d-flex flex-wrap gap-2 mt-2">
                          {(selectedSubscriptionStatus || []).map((status) => (
                            <span
                              key={status}
                              className="badge bg-info text-white"
                            >
                              {
                                {
                                  active: "Active",
                                  canceled: "Canceled",
                                  past_due: "Past Due",
                                  incomplete: "Incomplete",
                                  incomplete_expired: "Incomplete Expired",
                                  trialing: "Trialing",
                                  unpaid: "Unpaid",
                                  none: "No Subscription",
                                }[status]
                              }
                              <button
                                type="button"
                                className="btn-close btn-close-white ms-2"
                                aria-label="Close"
                                onClick={() =>
                                  setSelectedSubscriptionStatus(
                                    (selectedSubscriptionStatus || []).filter(
                                      (item) => item !== status
                                    )
                                  )
                                }
                              ></button>
                            </span>
                          ))}
                        </div>
                      </div>
                      <div className="dropdown d-inline-block">
                        <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn btn-light"
                            type="button"
                            caret
                          >
                            Filter by Type
                          </DropdownToggle>
                          <DropdownMenu>
                            {Object.values(userType).map((type) => (
                              <DropdownItem key={type} toggle={false}>
                                <div className="form-check">
                                  <input
                                    checked={selectedUserType.includes(type)}
                                    name={type}
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`filter-${type}`}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      const updatedSelectedUserType = checked
                                        ? [...selectedUserType, type]
                                        : selectedUserType.filter(
                                          (item) => item !== type
                                        );
                                      setSelectedUserType(
                                        updatedSelectedUserType
                                      );
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`filter-${type}`}
                                  >
                                    {(() => {
                                      switch (type) {
                                        case userType.ADMIN:
                                          return "Admin";
                                        case userType.FINALANALYSIS:
                                          return "Final Analysis";
                                        case userType.STOCKCHECK:
                                          return "Stock Check";
                                        case userType.INITIALANALYSIS:
                                          return "Initial Analysis";
                                        case userType.BC:
                                          return "Buyers Club";
                                        default:
                                          return "Unknown";
                                      }
                                    })()}
                                  </label>
                                </div>
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <div className="d-flex flex-wrap gap-2 mt-2">
                          {selectedUserType.map((type) => (
                            <span
                              key={type}
                              className={`badge ${getTypeColor(
                                type
                              )} text-white`}
                            >
                              {(() => {
                                switch (type) {
                                  case userType.ADMIN:
                                    return "Admin";
                                  case userType.FINALANALYSIS:
                                    return "Final Analysis";
                                  case userType.STOCKCHECK:
                                    return "Stock Check";
                                  case userType.INITIALANALYSIS:
                                    return "Initial Analysis";
                                  case userType.BC:
                                    return "Buyers Club";
                                  default:
                                    return "Unknown";
                                }
                              })()}
                              <button
                                type="button"
                                className="btn-close btn-close-white ms-2"
                                aria-label="Close"
                                onClick={() =>
                                  setSelectedUserType(
                                    selectedUserType.filter(
                                      (item) => item !== type
                                    )
                                  )
                                }
                              ></button>
                            </span>
                          ))}
                        </div>
                      </div>
                      <div className="dropdown d-inline-block">
                        <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn btn-light"
                            type="button"
                            caret
                          >
                            Type of Membership
                          </DropdownToggle>
                          <DropdownMenu>
                            {[
                              { value: "Regular", label: "Regular" },
                              { value: "BPA", label: "BPA" },
                              { value: "Team", label: "Team" },
                              { value: "Trial", label: "Trial" },
                              { value: "Other", label: "Other" },
                            ].map((membership) => (
                              <DropdownItem key={membership.value} toggle={false}>
                                <div className="form-check">
                                  <input
                                    checked={
                                      Array.isArray(selectedMembershipType)
                                        ? selectedMembershipType.includes(membership.value)
                                        : false
                                    }
                                    name={membership.value}
                                    type="checkbox"
                                    className="form-check-input"
                                    id={`filter-membership-${membership.value}`}
                                    onChange={(e) => {
                                      const checked = e.target.checked;
                                      const updated = checked
                                        ? [...(selectedMembershipType || []), membership.value]
                                        : (selectedMembershipType || []).filter(
                                            (item) => item !== membership.value
                                          );
                                      setSelectedMembershipType(updated);
                                    }}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`filter-membership-${membership.value}`}
                                  >
                                    {membership.label}
                                  </label>
                                </div>
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                        <div className="d-flex flex-wrap gap-2 mt-2">
                          {(selectedMembershipType || []).map((membership) => (
                            <span
                              key={membership}
                              className="badge bg-secondary text-white"
                            >
                              {membership}
                              <button
                                type="button"
                                className="btn-close btn-close-white ms-2"
                                aria-label="Close"
                                onClick={() =>
                                  setSelectedMembershipType(
                                    (selectedMembershipType || []).filter(
                                      (item) => item !== membership
                                    )
                                  )
                                }
                              ></button>
                            </span>
                          ))}
                        </div>
                      </div>
                      <div className="d-flex gap-1 flex-wrap">
                        <button
                          type="button"
                          className="btn btn-success add-btn btn-sm"
                          id="create-btn"
                          onClick={() => {
                            setOpenAddUser(true);
                          }}
                        >
                          <i className="ri-add-line align-bottom "></i> Add User
                        </button>
                      </div>
                      <div className="d-flex gap-1 flex-wrap">
                        <button
                          type="button"
                          className="btn btn-info add-btn btn-sm"
                          id="create-btn"
                          onClick={() => {
                            getUsers(null, null, true);
                          }}
                        >
                          <i className="ri-add-line align-bottom me-1"></i>{" "}
                          Download
                        </button>
                      </div>
                    </div>
                  </div>
                </Row>
              </CardHeader>

              <Row className="mb-3">
                <CardBody className="border border-dashed border-end-0 border-start-0">
                  <form onSubmit={(e) => e.preventDefault()}>
                    <Row>
                      <Col sm={5}>
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <DebouncedInput
                            value={searchText ?? ""}
                            onChange={(value) => setSearchText(value)}
                            placeholder="Search user"
                          />
                          <i className="bx bx-search-alt search-icon"></i>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Row>
              <div>
                {loading ? (
                  <Loader />
                ) : usersList && usersList.length > 0 ? (
                  <TableContainer
                    columns={columns}
                    data={usersList || []}
                    isGlobalFilter={true}
                    isAddUserList={false}
                    customPageSize={10}
                    divClass="table-responsive mb-1"
                    tableClass="mb-0 align-middle table-borderless"
                    theadClass="table-light text-dark text-uppercase"
                    isProductsFilter={true}
                    SearchPlaceholder="Search Supplier..."
                    pagination={pagination}
                    manualPagination={true}
                    onPreviousPage={() => {
                      getUsers(pagination.currentPage - 1);
                    }}
                    onNextPage={() => {
                      getUsers(pagination.currentPage + 1);
                    }}
                    onGetPage={(page, pageSize) => {
                      getUsers(page, pageSize);
                    }}
                    currentSortBy={sortBy}
                    currentSortAsc={sortAsc}
                    onSortChange={(field, asc) => {
                      setSortBy(field);
                      setSortAsc(asc);
                    }}
                  />
                ) : (
                  <div className="py-4 text-center">
                    <div>
                      <lord-icon
                        src="https://cdn.lordicon.com/msoeawqm.json"
                        trigger="loop"
                        colors="primary:#405189,secondary:#0ab39c"
                        style={{ width: "72px", height: "72px" }}
                      ></lord-icon>
                    </div>

                    <div className="mt-4">
                      <h5>Sorry! No Users Found</h5>
                    </div>
                  </div>
                )}
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Users;
